export const CurrencyCodesObj = {
  CAD: '124',
  USD: '840',
  EUR: '978',
  GBP: '826',
  JPY: '392',
  CNY: '156',
} as const;

export type TCurrencyCode = (typeof CurrencyCodesObj)[keyof typeof CurrencyCodesObj];

export type TISO3166CodeObjKey = TCurrencyCode | 'default';
export type TISO3166CodeObjValue = { iso3166Code: string; iso4217CurrencyCode: string };

const ISO3166CodeObj = new Map<TISO3166CodeObjKey, TISO3166CodeObjValue>([
  [CurrencyCodesObj.CAD, { iso3166Code: 'CA', iso4217CurrencyCode: 'CAD' }],
  [CurrencyCodesObj.USD, { iso3166Code: 'US', iso4217CurrencyCode: 'USD' }],
  [CurrencyCodesObj.EUR, { iso3166Code: 'DE', iso4217CurrencyCode: 'EUR' }],
  [CurrencyCodesObj.GBP, { iso3166Code: 'GB', iso4217CurrencyCode: 'GBP' }],
  [CurrencyCodesObj.JPY, { iso3166Code: 'JP', iso4217CurrencyCode: 'JPY' }],
  [CurrencyCodesObj.CNY, { iso3166Code: 'CN', iso4217CurrencyCode: 'CNY' }],

  ['default', { iso3166Code: 'US', iso4217CurrencyCode: 'USD' }],
]);

export const getISO3166CodeFromCurrency = (
  currencyCode: string | undefined,
): {
  iso3166Code: string;
  iso4217CurrencyCode: string;
} => {
  return currencyCode
    ? ((ISO3166CodeObj.get(currencyCode as TISO3166CodeObjKey) ?? ISO3166CodeObj.get('default')) as TISO3166CodeObjValue)
    : (ISO3166CodeObj.get('default') as TISO3166CodeObjValue);
};
